import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'

import '@mdi/font/css/materialdesignicons.min.css'
import './assets/css/global.css'

import { createVuetify } from 'vuetify'

import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader

import './registerServiceWorker'
import { StatusServiceInstance } from '@/lynxapi'

import VueMask from '@devindex/vue-mask'

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light'
  }
})

// Stop error resizeObserver
const debounce = (callback, delay) => {
  let tid
  return function (...args) {
    const ctx = this
    if (tid) clearTimeout(tid)
    tid = setTimeout(() => {
      callback.apply(ctx, args)
    }, delay)
  }
}

const _ = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ {
  constructor (callback) {
    callback = debounce(callback, 20)
    super(callback)
  }
}

const pinia = createPinia()

createApp(App).use(router).use(pinia).use(vuetify).use(VueMask).mount('#app')

// start the Lynx REST status api
StatusServiceInstance.startCheckingServerStatus()
